export default __webpack_public_path__ + "media/images/shde-right2-a53489987044355cc54a230bcf3e256b.png";